<template lang="pug">
#setInbox.inbox.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='ppg-tab')
  .tab-content
    .epw-nwrap.inbox-wrap
      //- .abtn-group
        a.abtn.epw-ntabs.active(href='javascript:void(0)') Gift Inbox
        //- a.abtn.epw-ntabs.active(href='javascript:void(0)' dd='inbox-gift') Gift Inbox
        //- a.abtn.epw-ntabs(href='javascript:void(0)' dd='inbox-rewards')
          | Extra Rewards 
          span.dot.dot-blink 1
      .inboxcons.epw-ncons.active(dd='inbox-gift')
        h5 {{$t('ui.subject')}}
        template(v-if="startRender")
          template(v-if="inboxList.length > 0")
            #accordion
              .tnc-card.unread(v-for="(msg, index) in inboxList")
                button.btn-tnc.collapsed(data-bs-toggle='collapse' :data-bs-target="'#inboxgift'+index" aria-expanded='false' aria-controls='inboxgift1')
                  .tncsplit
                    .info {{ $moment(msg.created_date).format("YYYY-MM-DD HH:mm:ss") }}
                    .desc {{msg.campaign_name}}
                  span.dot.v2.dot-blink NEW
                .collapse(data-bs-parent='#accordion' :id="'inboxgift'+(index)" style='')
                  template(v-if="msg.campaign == 'FORTUNEWHEEL'")
                    .tnc-body.v2
                      p {{msg.campaign_name}}
                      h5 {{$t('ui.amount')}}: {{msg.amount}}
                      .text-center
                        button.btn-submit.v2(type='button' v-if="!loading" @click="claimInbox(msg.id)") {{$t('ui.claim')}}
                        button.btn-submit.v2.disabled-grey(type='button' v-else)
                          i.fas.fa-duotone.fa-spinner.fa-spin-pulse
                  template(v-else)
                    .tnc-body.v2(v-if="msg.remark!='' && msg.remark != null") 
                      p {{msg.remark}}
                      h5 {{$t('ui.amount')}}: {{msg.amount}}
                      p.text-danger(v-if="msg.expiry_date !== null" ) {{$t('ui.expiry_date')}}: {{ $moment(msg.expiry_date).format("YYYY-MM-DD HH:mm:ss") }}
                      p.text-warning(v-if="msg.campaign =='DAILYMISSION'") *This bonus cannot be combined with other deposit offers or promotions unless stated otherwise."
                      .text-center
                        button.btn-submit.v2(type='button' v-if="!loading" @click="claimInbox(msg.id)") {{$t('ui.claim')}}
                        button.btn-submit.v2.disabled-grey(type='button' v-else)
                          i.fas.fa-duotone.fa-spinner.fa-spin-pulse
          template(v-else)
            .tnc-body.text-center {{ $t("ui.no_new_message") }}
        template(v-else)
          .text-center
            i.fas.fa-duotone.fa-spinner.fa-spin-pulse
//- #inbox.tab-pane.nopad.fade.show.active(role='tabpanel' aria-labelledby='inbox-tab')
  .table-responsive.statement-desktop
    table.table-history
      thead
        tr
          th {{$t('ui.date')}}
          th {{$t('ui.subject')}}
          th {{$t('ui.remarks')}}
          th.text-center {{$t('ui.amount')}}
          th 
      tbody
        template(v-if="startRender")
          template(v-if="inboxList.length > 0")
            tr(v-for="(msg, index) in inboxList")
              td {{ $moment(msg.created_date).format("YYYY-MM-DD HH:mm:ss") }}
              td.unread {{msg.campaign_name}}
              td.unread(v-if="msg.remark!='' && msg.remark != null") {{msg.remark}}
              td(v-else) -
              td.unread.text-center {{msg.amount}}
              td.delete
                .btn-sub.p-2(v-if="!loading" @click="claimInbox(msg.id)") {{$t('ui.claim')}}
                .btn-sub.p-2.disabled-grey(v-else)
                  i.fas.fa-duotone.fa-spinner.fa-spin-pulse
          template(v-else)
            tr
              td.text-center(colspan="5") {{ $t("ui.no_new_message") }}    
  .statement-mobile
    template(v-if="startRender")
      template(v-if="inboxList.length > 0")
        .statement-single(v-for="(msg, index) in inboxList")
          .statement-single-content
            .statement-date.redeem
              .text-capitalize
              div {{ $moment(msg.created_date).format("YYYY-MM-DD HH:mm:ss") }}
            .statement-detail
              .statement-detail-left {{$t('ui.item')}}
              .statement-detail-right {{msg.campaign_name}}
            .statement-detail
              .statement-detail-left {{$t('ui.remarks')}}
              .statement-detail-right(v-if="msg.remark!='' && msg.remark != null")
                span.text-green.fw-bold {{msg.remark}}
              .statement-detail-right(v-else) -
            .statement-detail
              .statement-detail-left {{$t('ui.amount')}}
              .statement-detail-right
                span.text-green.fw-bold {{msg.amount}}
            .statement-detail.justify-content-center
              .btn-sub.w-50.p-2(v-if="!loading" @click="claimInbox(msg.id)") {{$t('ui.claim')}}
              .btn-sub.w-50.p-2.disabled-grey(v-else)
                i.fas.fa-duotone.fa-spinner.fa-spin-pulse
      template(v-else)
        .statement-single.text-center.py-2 {{ $t("ui.no_new_message") }}
</template>
<script>
// import balance from '@/component/_balance.vue'
export default {
  components:{
    // balance
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      loading: false,
      startRender: false
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    inboxList(){
      return this.$store.state.user.inbox
    }
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
  mounted(){
    this.getInbox()
  },
  methods:{
    getInbox(){
      if(this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.loading = true
        this.$store
          .dispatch("user/getInbox", { account_id, auth_token })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.startRender = true
            } else {
              this.feedback.status = this.$t("error." + response.status)
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status)
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    claimInbox(id){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let inbox_id = id
        this.loading = true
        this.$store
          .dispatch("user/claimInbox", { account_id, auth_token, inbox_id })
          .then(response => {
            this.loading = false
            if (response.success == true) {
              this.$swal({
                title: vm.$tc("ui.success"),
                type: "success"
              }).then(result => {
                // vm.$router.push("/").catch(error =>{})
              });
              // this.$helpers.showDialog(this.$t('ui.success'), "", "success", this);
              this.getInbox()
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false
            if((typeof response.status) != 'object'){
              if(response.status === "ftd_required"){
                this.$swal({
                  customClass: {
                    confirmButton: 'btn-deposit',
                    cancelButton: 'btn-info'
                  },
                  // buttonsStyling: false,
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.ftd_required"),
                  type: "info",
                  showCancelButton: true,
                  confirmButtonText: vm.$tc("ui.deposit_now"),
                  cancelButtonText: "Live Chat",
                }).then(result => {
                  if (result.value) {
                    this.$router.push("deposit").catch(error =>{})                
                  }else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      // $('#modal-tnc').modal('show')
                      LiveChatWidget.call("maximize");
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.info{
  min-width: 0;
  flex: 0 1 auto;
  max-width: 30%;
  white-space: normal;
  overflow-wrap: anywhere;
  word-wrap: break-word;
  word-break: break-all;
  hyphens: auto; 
}
.desc{
  flex: 1 1 auto;
  min-width: 0;
}
</style>